import React, { useState, useEffect} from "react";
import axios from "../utils/axios";


function ContactFormModal({receiverId, itemId, setlang}) {
  const [consoleError, setConsoleError] = useState("");
  const [subject, setSubject] = useState("");
  const [body, setBody] = useState("");
  const [status, setStatus] = useState("");


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post("messages/", {
        receiver: receiverId,
        prodId: itemId,
        subject,
        body,
      });
      setStatus(setlang==="en"?"Message sent!":"پیام ارسال شد");
      setSubject("");
      setBody("");
      
    } catch (error) {
        if (error.response) {
          setConsoleError("Send failed:", error.response.status, error.response.data);
        } else {
          setConsoleError("Send failed:", error.message);
        }
        setStatus(setlang==="en"?"Failed to send message":"در ارسال پیام مشکلی رخ داد");
      }
  };

  return (
    <>
        <div className="contact-container-modal">
          <h2 className="registration-heading" style={{fontSize:"1.3rem"}}>{setlang === "en" ? "Contact Form" : "فرم تماس"}</h2>
          <form onSubmit={handleSubmit} className={setlang === "en" ? "contact-form-en" : "contact-form-fa" }>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder={setlang === "en" ? "Subject" : "عنوان" }
            />
            <textarea
              style={{ 
                width: "100%", 
                height: "250px", 
                padding: "10px", 
                resize: "vertical", 
                overflowX: "auto",
                fontSize:'1rem',
                marginBottom:'1rem',
                border: '1.5px solid #ddddddba',
                borderRadius: '8px',
              }}
              placeholder={setlang === "en" ? "Your message..." : " ..... پیام شما"}
              value={body}
              onChange={(e) => setBody(e.target.value)}
            />
            <div className="contact-form-action">
                <button type="submit"> {setlang === "en" ? "Send" : "ارسال"} </button>
            </div>
          </form>
          {status && <p>{status}</p>}
        </div>
    </>
  );
} export default ContactFormModal;
